.gr-scroll-lock {
  overflow: hidden !important;
}

:host {
  /**
   * @prop --panel-background-color: Background color of the dropdown panel
   *
   * @prop --panel-border-radius: Border radius of the dropdown panel
   * @prop --panel-border-color: Border color of the button
   *
   * @prop --panel-box-shadow: Box shadow of the dropdown panel
   *
   * @prop --transition: Transition of the dropdown
   */
  --panel-background-color: var(--gr-color-white);
  --panel-border-radius: var(--gr-border-radius-medium);
  --panel-border-color: var(--gr-panel-border-color);
  --panel-box-shadow: var(--gr-shadow-large);
  --transition: 150ms opacity, 150ms transform;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
}
:host *, :host *:before, :host *:after {
  box-sizing: inherit;
}

.dropdown-trigger {
  display: block;
}

.dropdown-positioner {
  position: absolute;
  z-index: var(--gr-z-index-dropdown);
}

.dropdown-panel {
  max-height: 50vh;
  font-family: var(--gr-font-family);
  font-size: var(--gr-font-size-medium);
  font-weight: var(--gr-font-weight-normal);
  background-color: var(--panel-background-color);
  border: solid 1px var(--panel-border-color);
  border-radius: var(--panel-border-radius);
  box-shadow: var(--panel-box-shadow);
  opacity: 0;
  overflow: auto;
  overscroll-behavior: none;
  pointer-events: none;
  transform: scale(0.9);
  transition: var(--transition);
}

.dropdown-positioner[data-popper-placement^=top] .dropdown-panel {
  transform-origin: bottom;
}
.dropdown-positioner[data-popper-placement^=bottom] .dropdown-panel {
  transform-origin: top;
}
.dropdown-positioner[data-popper-placement^=left] .dropdown-panel {
  transform-origin: right;
}
.dropdown-positioner[data-popper-placement^=right] .dropdown-panel {
  transform-origin: left;
}
.dropdown-positioner.popover-visible .dropdown-panel {
  opacity: 1;
  transform: none;
  pointer-events: all;
}